module.exports = __webpack_public_path__ + "static/img/图片 51.6399cb32.png";